module.exports = __webpack_public_path__ + "static/media/inbox.7faa004b.svg";